import { Injectable } from "@angular/core";
import { MapperInterface } from "./mapper-inteface";

import { MapperDifferenza } from "./mapper-differenza";
import { MapperFascicolo } from "./mapper-fascicolo";
import { MapperUtente } from "./mapper-utente";
import { MapperUnitaDocumentaria } from "./mapper-unita-documentaria";
import { MapperIperFascicolo } from "./mapper-iper-fascicolo";
import { AttivitaUnitaDocumentariaDTO } from "../dto/attivita-unita-documentariaDTO";
import { AttivitaUnitaDocumentariaVO } from "../vo/attivita-unita-documentariaVO";

@Injectable({
  providedIn: "root",
})
export class MapperAttivitaUnitaDocumentaria
  implements MapperInterface<AttivitaUnitaDocumentariaDTO, AttivitaUnitaDocumentariaVO> {
  constructor(
    private mapperDifferenze: MapperDifferenza,
    private mapperUtente: MapperUtente,
    private mapperFascicolo: MapperFascicolo,
    private mapperIperFascicolo: MapperIperFascicolo,
    private mapperUd: MapperUnitaDocumentaria
  ) {}
  convertVoToDto(vo: AttivitaUnitaDocumentariaVO): AttivitaUnitaDocumentariaDTO {
    if (vo != null) {
      const dto = new AttivitaUnitaDocumentariaDTO();
      dto.dataOperazione = vo.dataOperazione;
      dto.differenze = this.mapperDifferenze.convertListVoToDto(vo.differenze);
      dto.tipoOperazione = vo.tipoOperazione;
      dto.idFascicolo = vo.idFascicolo;
      dto.idUnitaDocumentaria = vo.idUnitaDocumentaria;
      dto.operatore = this.mapperUtente.convertVoToDto(vo.operatore);
      return dto;
    } else {
      return null;
    }
  }

  convertDtoToVo(dto: AttivitaUnitaDocumentariaDTO): AttivitaUnitaDocumentariaVO {
    if (dto != null) {
      const vo = new AttivitaUnitaDocumentariaVO();
      vo.dataOperazione = dto.dataOperazione;
      vo.differenze = this.mapperDifferenze.convertListDtoToVo(dto.differenze);
      vo.tipoOperazione = dto.tipoOperazione;
      vo.idFascicolo = dto.idFascicolo;
      vo.idUnitaDocumentaria = dto.idUnitaDocumentaria;
      vo.operatore = this.mapperUtente.convertDtoToVo(dto.operatore);
     
      return vo;
    } else {
      return null;
    }
  }
  convertListVoToDto(e: AttivitaUnitaDocumentariaVO[]): AttivitaUnitaDocumentariaDTO[] {
    if (e != null) {
      return e.map((vo) => this.convertVoToDto(vo));
    } else {
      return null;
    }
  }
  convertListDtoToVo(t: AttivitaUnitaDocumentariaDTO[]): AttivitaUnitaDocumentariaVO[] {
    if (t != null) {
      return t.map((vo) => this.convertDtoToVo(vo));
    } else {
      return null;
    }
  }
}
